import { useEffect, useRef, useState } from "react";
import SquidgameVisualizer from "./SquidgameVisualizer";


interface KpopInfoMusic {
    title: string;
    artist: string;
    year: number;
    minuteRuntime: number;
    producer: string;
    imageUrl?: string;
    badges?: string[];
    backgroundColor?: string;
    darkText?: boolean;
    songUrl: string;
    information: string;
}

const RecentSection = () => {

    const kpopInfoExample: KpopInfoMusic[] = [{
        title: "Dynamite",
        artist: "BTS",
        year: 2020,
        minuteRuntime: 3,
        producer: "Pdogg",
        imageUrl: "https://i.scdn.co/image/ab67616d0000b273c07d5d2fdc02ae252fcd07e5",
        badges: ["Grammy Nominated", "Uni days"],
        backgroundColor: "#A7EBBA",
        darkText: true,
        songUrl: "/music/original_Dynamite.mp3",
        information: "BTS (bangtan sonyeondan) is a South Korean boy band formed in 2013 under Big Hit Entertainment. The group consists of seven members: RM, Jin, Suga, J-Hope, Jimin, V, and Jungkook. Known for their dynamic performances, meaningful lyrics, and strong connection with fans (known as ARMY), BTS has achieved global success and recognition, breaking numerous records and winning various awards."
    },
    {
        title: "Haru Haru",
        artist: "BIGBANG",
        year: 2008,
        minuteRuntime: 4,
        producer: "G-Dragon",
        imageUrl: "https://i.scdn.co/image/ab67616d0000b273256b86508bfdc54899e4685e",
        badges: ["My fav"],
        songUrl: "/music/original_haruharu.mp3",
        backgroundColor: "#003769",
        information: "BIGBANG is a South Korean boy band formed in 2006 under YG Entertainment. The group consists of five members: G-Dragon, T.O.P, Taeyang, Daesung, and Seungri (who departed in 2019). BIGBANG is known for their unique blend of hip hop, R&B, and pop music, as well as their charismatic stage presence. They have been influential in shaping the K-pop industry and have a massive international fanbase."

    },
    {
        title: "Love Love Love",
        artist: "Epik High",
        year: 2007,
        minuteRuntime: 5,
        producer: "Tablo",
        imageUrl: "https://i.scdn.co/image/ab67616d0000b2734c71e80a8f580184ba910222",
        badges: ["My fav"],
        songUrl: "/music/original_Love Love Love.mp3",
        backgroundColor: "#303030",
        darkText: false,
        information: "Epik High is a South Korean alternative hip hop group formed in 2001. The group consists of members Tablo, Mithra Jin, and DJ Tukutz. Known for their introspective lyrics and innovative sound, Epik High has been influential in shaping the Korean hip hop scene. Their music often explores themes of love, loss, and social issues, resonating with a wide audience both in South Korea and internationally."
    },
    {
        title: "Gangnam Style",
        artist: "PSY",
        year: 2012,
        minuteRuntime: 4,
        producer: "PSY",
        imageUrl: "https://i.scdn.co/image/ab67616d0000b2736cfc57e5358c5e39e79bccbd",
        badges: ["Most Viewed YouTube Video (2012)"],
        backgroundColor: "#7F3300",
        darkText: false,
        songUrl: "/music/original_Gangnam Style.mp3",
        information: "PSY, whose real name is Park Jae-sang, is a South Korean singer, rapper, songwriter, and record producer. He gained international fame with his 2012 hit single 'Gangnam Style,' which became a global phenomenon and was the first YouTube video to reach one billion views. Known for his humorous and energetic performances, PSY has played a significant role in popularizing K-pop worldwide."
    }
    ];
    const [currentKpopInfo, setCurrentKpopInfo] = useState<KpopInfoMusic | null>(null);
    const currentAudioRef = useRef<HTMLAudioElement>(null);

    useEffect(() => {
        if (currentAudioRef.current && currentKpopInfo) {
            currentAudioRef.current.pause();
            currentAudioRef.current.src = currentKpopInfo.songUrl;
            currentAudioRef.current.load();
            currentAudioRef.current.play();
        } else if (currentKpopInfo == null && currentAudioRef.current) {
            currentAudioRef.current.pause();
            currentAudioRef.current.src = "";
        }
    }, [currentKpopInfo]);

    const transparentCardStyle = `bg-white/20 backdrop-blur-sm border border-white/30 rounded-2xl  shadow-xl`;

    return <div className="text-neutral-content">
        <h2 className="text-3xl font-bold mb-4">Recently...</h2>
        <div className="md:flex flex-row w-full gap-4 mt-4 items-center justify-center">
            <div className="w-full mb-4">
                I visited the museum to see a korean wave exhibition. I had started following k-pop since 2009 so I was inspired to try the following 2 sketches.
                First one was an exercise in copying the UI of one of the music information stands.
                Second is me practising using Three.js to create a 3D scene audio visualizer using a squid game model.
            </div>
            <div className="w-full">
                <img src="/played these game before.png" alt="Kpop Museum pictures" className="rounded-box shadow-xl object-contain" />
            </div>
        </div>

        <div className="flex flex-col lg:flex-row  gap-4 mt-4  justify-center items-center">
            <div className="w-full h-[200px] lg:h-[500px] lg:flex-1 min-w-0 items-stretch">
                <SquidgameVisualizer />
            </div>

            <div className=" w-full lg:flex-1 min-w-0 card bg-accent text-accent-content shadow-xl transition-colors"
                style={{ backgroundColor: currentKpopInfo ? "black" : undefined }}
            >
                <audio ref={currentAudioRef} />
                {currentKpopInfo ?
                    <div className="max-h-[480px] overflow-hidden">
                        <div className="flex flex-row gap-4  items-center m-4 bg-black">
                            <button className=" w-20 h-20  border-none bg-transparent" onClick={() => setCurrentKpopInfo(null)}>
                                <svg viewBox="0 0 24 24" className="stroke-neutral-content" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M4 12L20 12M4 12L10 6M4 12L10 18" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg>
                            </button>
                            <h2 className="text-4xl text-neutral-content font-bold">{currentKpopInfo.artist.toUpperCase()}</h2>
                        </div>
                        <div className="relative p-8 h-full"
                            style={{ backgroundColor: currentKpopInfo.backgroundColor ? currentKpopInfo.backgroundColor : undefined }}
                        >


                            <div className={transparentCardStyle + ` ${currentKpopInfo?.darkText ? "text-neutral" : "text-neutral-content"}`}>

                                <div className="flex flex-row w-full justify-between gap-4 items-center">
                                    <div className="flex flex-col py-6 px-6">
                                        <h3>NOW PLAYING</h3>
                                        <h2 className="text-2xl font-bold mb-2">{currentKpopInfo.title}</h2>
                                    </div>
                                    <div className="mr-4">
                                        <img src={currentKpopInfo.imageUrl} alt={currentKpopInfo.title} className="w-20 h-20 object-contain" />

                                    </div>

                                </div>


                            </div>
                            <div className={transparentCardStyle + " mt-4 p-6"}>
                                <p className={`${currentKpopInfo?.darkText ? "text-neutral" : "text-neutral-content"}`}>
                                    {currentKpopInfo.information}
                                </p>
                            </div>
                        </div>



                        <div className="p-10"
                        style={{ backgroundColor: currentKpopInfo ? currentKpopInfo.backgroundColor : undefined }}
                        >
                        <div >
                            <div className={transparentCardStyle + ` ${currentKpopInfo?.darkText ? "text-neutral" : "text-neutral-content"}`}>
                                <h3>NOW PLAYING</h3>
                                <h2 className="text-2xl font-bold mb-2">{currentKpopInfo.title}</h2>
                            </div>
                            <div className={transparentCardStyle + " mt-4"}>
                                <p className={`${currentKpopInfo?.darkText ? "text-neutral" : "text-neutral-content"}`}>
                                    Epik High is a South Korean alternative hip hop group formed in 2001. The group consists of members Tablo, Mithra Jin, and DJ Tukutz. Known for their introspective lyrics and innovative sound, Epik High has been influential in shaping the Korean hip hop scene. Their music often explores themes of love, loss, and social issues, resonating with a wide audience both in South Korea and internationally.
                                </p>
                            </div>
                        </div>
                     </div>

                    </div> :
                    <div className="flex flex-row overflow-x-auto w-full m-2 gap-4 p-4">
                        {
                            kpopInfoExample.sort((a, b) => a.year - b.year).map((info) => (
                                <div key={info.title}
                                    className={`cursor-pointer flex-shrink-0 w-[200px] md:w-[280px]     flex flex-col ${info.backgroundColor ? `bg-[${info.backgroundColor}]` : "bg-neutral"} ${info.darkText ? "text-neutral" : "text-neutral-content"}  rounded-box `}
                                    style={{ backgroundColor: info.backgroundColor ? info.backgroundColor : undefined }}
                                    onClick={() => setCurrentKpopInfo(info)}
                                >
                                    <div className="flex-shrink-0 w-full relative">
                                        <img src={info.imageUrl} alt={info.title} className="object-contain rounded-tl-box rounded-tr-box" />
                                        {info.badges && <div className="flex flex-row absolute left-0 bottom-0 m-4 gap-2">
                                            {info.badges.map((badge) => (
                                                <div key={badge} className="badge badge-neutral bg-primary text-neutral-content font-semibold">{badge}</div>
                                            ))}
                                        </div>}


                                    </div>

                                    <div className="flex-1 min-h-0">
                                        <div className="flex flex-col w-full h-full p-4 ">
                                            <h2 className="text-xl font-bold">{info.title}</h2>
                                            <h3 className="text-lg font-semibold">{info.artist}</h3>
                                            <h3 className="text-lg font-semibold">{info.year}</h3>

                                            <div className="text-sm mt-auto">
                                                <p>Run time: {info.minuteRuntime} mins</p>
                                                <p>{info.producer}</p>
                                            </div>


                                        </div>

                                    </div>
                                </div>
                            ))
                        }

                    </div>
                }

            </div>
        </div>







        <div>

        </div>


    </div>;
}

export default RecentSection;